import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    InputSignal,
    output,
    OutputEmitterRef,
    Signal
} from "@angular/core";
import {OrderingContextIntention} from '../ordering-context';
import {ButtonComponent} from "../../buttons/button/button.component";
import {ButtonProminence} from "../../buttons/button/button";
import {OrderingContextModel} from "../ordering-context.model";
import {OrderType} from '../../order/order';
import {ContentMessageComponent} from "../../notification/message/content-message.component";

@Component({
    selector: "woa-order-type-selection-panel",
    templateUrl: "./order-type-selection-panel.component.html",
    styleUrl: "./order-type-selection-panel.component.scss",
    imports: [
        ButtonComponent,
        ContentMessageComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTypeSelectionPanelComponent {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);

    OrderType = OrderType;
    ButtonProminence = ButtonProminence;

    public readonly intention: InputSignal<OrderingContextIntention> = input.required<OrderingContextIntention>();
    public readonly canOrderAtTable: InputSignal<boolean> = input.required<boolean>();
    public readonly canOrderAhead: InputSignal<boolean> = input.required<boolean>();
    public readonly canOrderDelivery: InputSignal<boolean> = input.required<boolean>();

    public onOrderTypeSelected: OutputEmitterRef<OrderType> = output<OrderType>();

    public readonly intro: Signal<string> = computed(() =>
        !this.intention() ||
        this.intention() === OrderingContextIntention.ORDER ||
        this.intention() === OrderingContextIntention.SELECT_ORDER_TYPE ||
        this.intention() === OrderingContextIntention.CHANGE_FULFILMENT_DETAILS ? undefined
            : this.orderingContextModel.singleStoreLocation() ? "woa.message.order-type-selection.intro.viewSingleStore"
                : this.intention() === OrderingContextIntention.VIEW_STORES ? "woa.message.order-type-selection.intro.viewStores"
                    : "woa.message.order-type-selection.intro.viewStore");

    public readonly orderAheadLabel: Signal<string> = computed(() =>
        this.intention() === OrderingContextIntention.VIEW_STORES ? "woa.button.order-type-selection.stores.orderAhead"
            : this.intention() === OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.button.order-type-selection.store.orderAhead"
                : "woa.button.order-type-selection.order.orderAhead");

    public readonly deliveryLabel: Signal<string> = computed(() =>
        this.intention() === OrderingContextIntention.VIEW_STORES ? "woa.button.order-type-selection.stores.orderDelivery"
            : this.intention() === OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.button.order-type-selection.store.orderDelivery"
                : "woa.button.order-type-selection.order.orderDelivery");

    public readonly orderAtTableLabel: Signal<string> = computed(() =>
        this.intention() === OrderingContextIntention.VIEW_STORES ? "woa.button.order-type-selection.stores.orderAtTable"
            : this.intention() === OrderingContextIntention.VIEW_CURRENT_STORE ? "woa.button.order-type-selection.store.orderAtTable"
                : "woa.button.order-type-selection.order.orderAtTable");
}
